export default (text) => {
  return text.match( /[^.!?]+[.!?]+/g );
}